/* ==========================================================================
   Imperfects — collection "HERO" (formerly "THE RUN")
   Progressive enhancement only. The page is complete and shoppable with this
   file absent: swatches fall back to links, video falls back to its poster,
   reveals never run (nothing is hidden without JS).
   No dependencies. Idempotent. Self-mounts.
   ========================================================================== */
(function (window, document) {
  'use strict';

  var MOUNTED = 'crMounted';

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* --- colour swatches --------------------------------------------------
     A swatch carries the variant's own image, URL and price. Clicking one
     swaps the card image, price and retargets the card link — it does NOT
     add to cart, and it does not navigate. The card remains a link to the
     PDP for that variant.
  --------------------------------------------------------------------- */
  function initSwatches(card) {
    var img = card.querySelector('[data-cr-img]');
    var link = card.matches('a') ? card : card.querySelector('[data-cr-link]');
    var price = card.querySelector('[data-cr-price]');
    var swatches = card.querySelectorAll('[data-cr-swatch]');
    if (!swatches.length) return;

    function select(btn) {
      for (var i = 0; i < swatches.length; i++) {
        swatches[i].setAttribute('aria-pressed', swatches[i] === btn ? 'true' : 'false');
      }
      var src = btn.getAttribute('data-cr-src');
      if (img && src && img.getAttribute('src') !== src) {
        var srcset = btn.getAttribute('data-cr-srcset');
        img.setAttribute('src', src);
        if (srcset) img.setAttribute('srcset', srcset);
        var alt = btn.getAttribute('data-cr-alt');
        if (alt) img.setAttribute('alt', alt);
      }
      var url = btn.getAttribute('data-cr-url');
      if (link && url) link.setAttribute('href', url);
      var priceText = btn.getAttribute('data-cr-price');
      if (price && priceText) price.textContent = priceText;
    }

    for (var i = 0; i < swatches.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function (e) {
          /* The swatch sits inside the card link — stop the navigation. */
          e.preventDefault();
          e.stopPropagation();
          select(btn);
        });
        btn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); select(btn); }
        });
      })(swatches[i]);
    }
  }

  /* --- video moments ---------------------------------------------------
     Loops are muted, playsinline, and only play while on screen. Under
     reduced-motion they never play and the poster stands in.
  --------------------------------------------------------------------- */
  function initVideo(video) {
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');

    if (reduceMotion()) { try { video.pause(); } catch (e) {} return; }

    if (!('IntersectionObserver' in window)) { try { video.play(); } catch (e) {} return; }

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {}); /* autoplay refusal is fine */
        } else {
          try { video.pause(); } catch (e) {}
        }
      }
    }, { threshold: 0.15 });
    io.observe(video);
  }

  /* --- paired-set add-to-cart --------------------------------------------
     Posts both variants to the theme's own cart (Theme.routes.cart_add_url)
     and dispatches the theme's own cart:update event so the existing cart
     drawer (auto-open) opens and the cart-items component refreshes itself.
     Not a second cart implementation.
  --------------------------------------------------------------------- */
  function initPairs(root) {
    var buttons = root.querySelectorAll('[data-cr-pair]');
    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var ids = (btn.getAttribute('data-cr-pair') || '').split(',');
          if (ids.length !== 2 || !ids[0] || !ids[1]) return;
          if (typeof Theme === 'undefined' || !Theme.routes || !Theme.routes.cart_add_url) return;

          var sectionIds = [];
          var cartItemsComponents = document.querySelectorAll('cart-items-component');
          for (var s = 0; s < cartItemsComponents.length; s++) {
            var sid = cartItemsComponents[s].dataset.sectionId;
            if (sid) sectionIds.push(sid);
          }

          btn.disabled = true;

          fetch(Theme.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [
                { id: ids[0], quantity: 1 },
                { id: ids[1], quantity: 1 }
              ],
              sections: sectionIds.join(','),
              sections_url: window.location.pathname
            })
          })
            .then(function (response) { return response.json(); })
            .then(function (data) {
              if (data && data.status) {
                console.error(data.message || data.description || 'Cart add failed');
                return;
              }
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: data,
                  sourceId: 'cr-pair',
                  data: {
                    source: 'collection-hero',
                    itemCount: 2,
                    sections: data && data.sections
                  }
                }
              }));
            })
            .catch(function (err) { console.error(err); })
            .finally(function () { btn.disabled = false; });
        });
      })(buttons[i]);
    }
  }

  /* --- band reveals ----------------------------------------------------- */
  function initReveals(root) {
    var targets = root.querySelectorAll('[data-cr-reveal]');
    if (!targets.length || reduceMotion() || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('is-in');
          io.unobserve(entries[i].target);
        }
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    for (var i = 0; i < targets.length; i++) io.observe(targets[i]);
  }

  function initCollectionRun(root) {
    if (!root || root.dataset[MOUNTED] === '1') return null;
    root.dataset[MOUNTED] = '1';

    var cards = root.querySelectorAll('[data-cr-card]');
    for (var i = 0; i < cards.length; i++) initSwatches(cards[i]);

    var videos = root.querySelectorAll('.cr__video-media');
    for (var v = 0; v < videos.length; v++) initVideo(videos[v]);

    initPairs(root);
    initReveals(root);

    return {
      root: root,
      refresh: function () {
        var c = root.querySelectorAll('[data-cr-card]');
        for (var j = 0; j < c.length; j++) initSwatches(c[j]);
      }
    };
  }

  function mountAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-cr]');
    for (var i = 0; i < roots.length; i++) initCollectionRun(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mountAll(); });
  } else {
    mountAll();
  }

  /* Shopify theme editor: sections are replaced wholesale. */
  document.addEventListener('shopify:section:load', function (e) {
    mountAll(e.target);
  });

  window.initCollectionRun = initCollectionRun;
})(window, document);
